module.exports = __webpack_public_path__ + "img/image02.2c8ccfa8.jpg";